/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_RegionInputs */

const en_edit_region = /** @type {(inputs: Edit_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Region`)
};

const es_edit_region = /** @type {(inputs: Edit_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar region`)
};

/**
* | output |
* | --- |
* | "Edit Region" |
*
* @param {Edit_RegionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const edit_region = /** @type {((inputs?: Edit_RegionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_RegionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edit_region(inputs)
	return es_edit_region(inputs)
});